'use strict';

define('lib/helpers/concat',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('concat', function () {
    var args = Array.prototype.slice.call(arguments, 0);
    var opt = args.pop();
    return args.join(opt.hash.sep || '');
  });
});

